import { render } from "./SpecialityFilter.vue?vue&type=template&id=01ed6e27&scoped=true"
import script from "./SpecialityFilter.vue?vue&type=script&lang=js"
export * from "./SpecialityFilter.vue?vue&type=script&lang=js"

import "./SpecialityFilter.vue?vue&type=style&index=0&id=01ed6e27&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ed6e27"]])

export default __exports__